export class Player {
    constructor() {
        this.endpoint = 'player'
        this.boot = [{ index : [
            () => {
                ui.select(':[data-action="delete"]').forEach( button => {
                    const row = button.parentElement.parentElement.parentElement,
                        name = row.querySelector('.lead').textContent
                    button.addEventListener('click',()=> {
                        ui.modal.instance({
                            title : __('Delete') + ' ' + name,
                            centered : true,
                            body : __('Are you sure you want to delete ') + name + '?',
                            buttonSave : __('Delete'),
                            buttonType : 'danger',
                            onSave() {
                                button.querySelector('form').submit()
                            }
                        })
                    })
                })

            }
        ]}]
    }
}